import { call, put, select, takeEvery } from 'redux-saga/effects';
import { getTimezoneOffsetCalculator } from 'selectors/serverSelectors';
import * as moment from 'moment';
import { setDate, VideoPlayAction } from 'actions/monitoringActions';
import { getDate } from 'selectors/monitoringSelectors';

export function* videoPlayWatcher() {
    yield takeEvery('VIDEO_PLAY', setDateAfterVideoPlay);
}

export function* setDateAfterVideoPlay(action: VideoPlayAction) {
    if (!action.payload.live) {
        return;
    }

    const tzOffsetCalculator = yield select(getTimezoneOffsetCalculator);
    const utcTime = yield call([ Date, 'now' ]);
    const offset = tzOffsetCalculator(utcTime);
    const liveDate =
        moment.utc(utcTime)
            .utcOffset(offset)
            .startOf('day')
            .toDate();

    const existingDate = yield select(getDate);
    if (liveDate.getTime() === existingDate.getTime()) {
        return;
    }

    yield put(setDate({ date: liveDate, preserveTimeOfDay: false }));
}



// WEBPACK FOOTER //
// ./src/sagas/shell/afterVideoPlaySaga.ts